import * as api from "@/api";

const initState = () => ({
  clid: null,
  smsid: "",
  phone: "",
  pass: "",
  code: "",
  stage: "start",
  invitation_id: undefined,
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    invitation_id: (state) => state.invitation_id,
    pass: (state) => state.pass,
    clid: (state) => state.clid,
    code: (state) => state.code,
    phone: (state) => state.phone,
    stage: (state) => state.stage,
    phoneNumber: (state) => state.phone.replace(/\D/g, ""),
    maskedPhone: (state) =>
      "+" +
      state.phone
        .replace(/\D/g, "")
        .split("")
        .map((l, i) => (i > 0 && i < 8 ? "*" : l))
        .join(""),
  },
  mutations: {
    reset: (state) => {
      const initialState = initState();
      Object.keys(initialState).forEach((key) => (state[key] = initialState[key]));
    },
    setPass: (state, value) => (state.pass = value),
    setClid: (state, value) => (state.clid = value),
    setSmsid: (state, value) => (state.smsid = value),
    setPhone: (state, value) => (state.phone = value),
    setStage: (state, stage) => (state.stage = stage),
    setCode: (state, code) => (state.code = code),
    setInvitationId: (state, id) => (state.invitation_id = id),
  },
  actions: {
    async init({ commit, getters: { phoneNumber } }) {
      const res = await api.initRegistration(phoneNumber);
      if (res) {
        commit("setSmsid", res.smsid);
        commit("setStage", "confirmation");
      }
    },

    async refresh({ commit, getters: { phoneNumber } }) {
      const res = await api.refreshRegistration(phoneNumber);
      if (res) {
        commit("setSmsid", res.smsid);
      }
    },

    async confirm({ commit, state }) {
      const res = await api.confirmRegistration(state.code, state.smsid);
      if (res) {
        commit("setPhone", res.phone);
        commit("setStage", "password");
      }
    },

    async register({ state: { pass, smsid, phone, clid, invitation_id } }) {
      const res = await api.register({ pass, smsid, phone, clid, invitation_id });
      return res;
    },
  },
};
